import {Injectable} from '@angular/core';
import {AngularFireAuth} from 'angularfire2/auth';
import {AngularFirestore} from 'angularfire2/firestore';
import {FormGroup} from '@angular/forms';
import * as moment from 'moment';
import 'moment-timezone';

// import Rx from 'rxjs/Rx';
import {Observable, ConnectableObservable} from 'rxjs';
// import { Subject }    from 'rxjs/Subject';
import {ReplaySubject} from 'rxjs';

import {SwalComponent} from '@toverux/ngx-sweetalert2';
import {Router} from '@angular/router';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/shareReplay';
import 'rxjs/add/operator/multicast';
import * as firebase from 'firebase';
import {ADMIN_LEVEL} from 'data/constants';
import {environment} from 'environments/environment';

@Injectable()
export class UserDataService {
    source: ConnectableObservable<any>;
    timezones: Array<any> = [];
    test: any;
    subscription: any;
    // userid: string;
    // userprofiles: any;
    // orgs: any;
    // vehicles: any;
    // org_userprofiles: any;
    // org_vehicles: any;
    // subject: any;
    userProfile: any;
    data: any;
    public isAdmin_CMS = environment['admin_CMS'] || false; // Manually setting, when deploy to firebase ADMIN host
    public orgList: any;
    public users$: any;
    public ADMIN_LEVEL = ADMIN_LEVEL;
    public ADMIN_LEVEL_OLD = {
        1: {
            lv: 1,
            allOrgList: false,
            modifyOrg: true,
            modifySales: false,
            editLimitAccount: true,
            editLimitVehicle: false,
            addVehicle: false,
            deleteElog: false,
            deleteEvent: false,
            queryTable: false,
            controlPanel: false,
            descripation: 'Contractor(Reseller)',
        },
        2: {
            lv: 2,
            allOrgList: false,
            modifyOrg: true,
            modifySales: false,
            editLimitAccount: true,
            editLimitVehicle: false,
            addVehicle: false,
            deleteElog: false,
            deleteEvent: false,
            queryTable: false,
            controlPanel: false,
            descripation: 'Sales Rep',
        },
        3: {
            lv: 3,
            allOrgList: false,
            modifyOrg: true,
            modifySales: false,
            editLimitAccount: true,
            editLimitVehicle: true,
            addVehicle: true,
            deleteElog: false,
            deleteEvent: true,
            queryTable: false,
            controlPanel: false,
            descripation: 'Service Rep (Limited)',
        },
        4: {
            lv: 4,
            allOrgList: true,
            modifyOrg: true,
            modifySales: true,
            editLimitAccount: true,
            editLimitVehicle: true,
            addVehicle: true,
            deleteElog: true,
            deleteEvent: true,
            queryTable: false,
            controlPanel: true,
            descripation: 'Field Support',
        },
        5: {
            lv: 5,
            allOrgList: true,
            modifyOrg: true,
            modifySales: true,
            editLimitAccount: true,
            editLimitVehicle: true,
            addVehicle: true,
            deleteElog: true,
            deleteEvent: true,
            queryTable: true,
            controlPanel: true,
            descripation: 'All Access',
        },
    };
    public adminLevel: any;

    filter_timezones = [
        'America/Halifax',
        'America/Los_Angeles',
        'America/New_York',
        'America/Chicago',
        'America/Denver',
        'America/Phoenix',
        'America/Anchorage',
    ];

    private swalDialog: SwalComponent = new SwalComponent({
        title: 'Inactive Warning',
        text: 'CAUTION! Your account is not active, please contact your organization manager.',
        type: 'warning',
        confirmButtonText: 'Logout',
        allowOutsideClick: false,
        allowEscapeKey: false,
    });

    private swalDialog_orgInactive: SwalComponent = new SwalComponent({
        title: 'Inactive Warning',
        text: 'This org is expired or not active',
        type: 'warning',
        confirmButtonText: 'ok',
        allowOutsideClick: false,
        allowEscapeKey: false,
    });

    public router: Router;

    constructor(public afAuth: AngularFireAuth, public afs: AngularFirestore, router: Router) {
        this.router = router;
        this.initTimezones();

        this.setDataSource();
        // .publishReplay(1)
        // .refCount();
    }

    setDataSource() {
        this.data = this.afAuth.authState.switchMap(
            auth => {
                console.log('auth changed !!!');
                console.log(auth);
                if (auth) {
                    auth.getIdToken().then(token => {
                        // this.token = token;
                        // console.log(token);
                    });
                }
                let profile: Observable<any> = auth
                    ? this.afs.doc(`/profiles/${auth.uid}`).valueChanges()
                    : Observable.of(null);
                return profile;
            },
            (auth, profile) => {
                this.userProfile = profile;
                return {userid: auth ? auth.uid : null, profile: profile};
            },
        );

        this.source = this.data
            .switchMap(
                user => {
                    return user.profile
                        ? this.afs.doc(`/orgs/${user.profile.orguid}`).valueChanges()
                        : Observable.of([]);
                },
                (user, org) => {
                    // console.log(user);
                    const orguid = user.profile ? user.profile.orguid : null;
                    this.checkValue(orguid, org.email, org.email_secondary, org.dotNumber);
                    return {
                        userid: user.userid,
                        profile: user.profile,
                        org: org,
                        orguid,
                    }; // add orguid for admin switch org data
                },
            )
            .do(user => {
                console.log(user);
                if (user.userid && user.org && user.profile) {
                    const adminLv = user.profile.isAdmin ? user.profile.adminLv : 0;
                    this.adminLevel = ADMIN_LEVEL[adminLv];
                    console.log(this.adminLevel);
                    if (user.org.isActive === false) {
                        this.showAccountInactiveWarning();
                    } else if (user.org['freeTrial']) {
                        const expiredAt = user.org['expiredAt'];
                        if (expiredAt && expiredAt.length > 0 && new Date() >= new Date(expiredAt)) {
                            this.showAccountInactiveWarning();
                        }
                    } else if (user.profile.isAdmin || (user.profile.isActive && !user.profile.isDeleted)) {
                        // this.showSafetyWarning();
                    } else if (
                        user.profile.isActive === user.profile.isDeleted &&
                        (user.profile.isActive == null || user.profile.isActive === '')
                    ) {
                        // older profile without these keys
                    } else {
                        this.showAccountInactiveWarning();
                    }
                }
            })
            // .shareReplay(1);
            .multicast(new ReplaySubject(1));

        this.subscription = this.source.connect();
    }

    admin_setDataSource(orgId) {
        console.log('admin reset data source for different company');
        if (this.userProfile.isAdmin !== true) {
            // check if user is admin
            console.log('not admin user');
            this.setDataSource();
            return;
        }

        this.source = this.data
            .switchMap(
                user => {
                    // console.log(user);
                    if (!orgId) {
                        orgId = user.profile.orguid;
                    }
                    // console.log(orgId);
                    return user.profile ? this.afs.doc(`/orgs/${orgId}`).valueChanges() : Observable.of([]);
                },
                (user, org) => {
                    // console.log(user);
                    this.checkValue(orgId, org.email, org.email_secondary, org.dotNumber);
                    return {
                        userid: user.userid,
                        profile: user.profile,
                        org: org,
                        orguid: orgId,
                    };
                },
            )
            .do(user => {
                console.log(user);
                if (user.userid && user.org && user.profile) {
                    if (user.org.isActive === false) {
                        this.swalDialog_orgInactive.show();
                        // this.showAccountInactiveWarning();
                    } else if (user.org['freeTrial']) {
                        const expiredAt = user.org['expiredAt'];
                        if (expiredAt && expiredAt.length > 0 && new Date() >= new Date(expiredAt)) {
                            this.swalDialog_orgInactive.show();
                            // this.showAccountInactiveWarning();
                        }
                    } else if (user.profile.isAdmin || (user.profile.isActive && !user.profile.isDeleted)) {
                        // this.showSafetyWarning();
                    } else if (
                        user.profile.isActive === user.profile.isDeleted &&
                        (user.profile.isActive == null || user.profile.isActive === '')
                    ) {
                        // older profile without these keys
                    } else {
                        // this.showAccountInactiveWarning();
                        this.swalDialog_orgInactive.show();
                    }
                }
            })
            // .shareReplay(1);
            .multicast(new ReplaySubject(1));
        this.subscription = this.source.connect();
    }

    public safeFillForm(form: FormGroup, data: any) {
        for (let field in form.controls) {
            // AffiliatedCompanies field of the form will be added to FormGroup as type FormArray dynamically in organization component.ts
            if (typeof data[field] !== 'undefined' && field !== 'affiliatedCompanies') {
                form.controls[field].setValue(data[field]);
            } else {
                // console.log(typeof form.controls[field]);
                // form.controls[field].setValue(null);
            }
        }

        // for(let key in data) {
        //   if(!form.controls[key]) {
        //     delete data[key];
        //   }
        // }
    }

    createDataLog(
        batch: firebase.firestore.WriteBatch,
        description,
        oldData: Object,
        newData: Object,
        operator,
        orgId,
    ) {
        const dataLogRef = this.afs.firestore.collection('dataLogs').doc();
        console.log('create data log');
        return batch.set(dataLogRef, {
            time: moment().unix(),
            date: moment().format('YYYY-MM-DD'),
            type: operator.isAdmin ? 'admin' : 'orgOwner',
            operatorId: operator.$key,
            operatorName: `${operator.firstName} ${operator.lastName}`,
            description,
            oldData: oldData,
            newData: newData,
            orgId,
        });
    }

    initTimezones() {
        // console.log(moment.tz.names());
        moment.tz
            .names()
            .filter(zone => {
                return zone.indexOf('America') !== -1 && this.filter_timezones.indexOf(zone) !== -1;
            })
            .forEach(zone => {
                this.timezones.push({
                    name: zone,
                    abbr: moment.tz(zone).zoneAbbr(),
                    utcOffset: moment.tz(zone).format('Z'),
                });
            });
    }

    showAccountInactiveWarning() {
        return new Promise<void>((resolve, reject) => {
            this.swalDialog.show().then(result => {
                if (result) {
                    this.afAuth.auth.signOut();
                    // localStorage.setItem('isLoggedin', 'false');
                    this.router.navigate(['/login']);
                    resolve();
                }
            });
        });
    }

    requireUserLoginAgain() {
        const swalDialog: SwalComponent = new SwalComponent({
            title: 'Account Modified',
            text: 'Please sign-in again.',
            type: 'warning',
            confirmButtonText: 'Logout',
            allowOutsideClick: false,
            allowEscapeKey: false,
        });

        return new Promise<void>((resolve, reject) => {
            swalDialog.show().then(result => {
                if (result) {
                    this.afAuth.auth.signOut();
                    // localStorage.setItem('isLoggedin', 'false');
                    this.router.navigate(['/login']);
                    resolve();
                }
            });
        });
    }

    actions2keyobjects(actions) {
        return actions.map(action => {
            // console.log(action);
            const data = action.payload.doc.data();
            const $key = action.payload.doc.id;
            return {$key, ...data};
        });
    }

    checkAdmin(user, page) {
        console.log(user);

        if (user.profile && user.profile.isAdmin) {
            switch (true) {
                case !user.org.isReseller && page == 'AccountsComponent':
                    return false;
                case !this.isAdmin_CMS && page != 'InstantLocationsComponent' && page != 'LocationHistoryComponent':
                    return false;
                default:
                    return true;
            }
        } else {
            return false;
        }
    }

    checkValue(orgId, email, emailSecondary, dotNumber) {
        if (!orgId) return;
        const trimEmail = email ? email.trim() : '';
        const trimEmailSecondary = emailSecondary ? emailSecondary.trim() : '';
        const trimDotNumber = dotNumber ? dotNumber.trim() : '';
        if (trimEmail != email || trimDotNumber != dotNumber || trimEmailSecondary != emailSecondary) {
            this.afs.firestore
                .collection('orgs')
                .doc(orgId)
                .update({
                    email: trimEmail,
                    email_secondary: trimEmailSecondary,
                    dotNumber: trimDotNumber,
                })
                .then(() => {
                    console.log('TRIM ORG INFO UPDATE');
                    console.log({email, trimEmail});
                    console.log({emailSecondary, trimEmailSecondary});
                    console.log({dotNumber, trimDotNumber});
                })
                .catch(err => console.log(err));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/user-data/user-data.service.ts